"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconDocument', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10,9 L6,9 C5.447,9 5,8.553 5,8 C5,7.447 5.447,7 6,7 L10,7 C10.553,7 11,7.447 11,8 C11,8.553 10.553,9 10,9 M10,13 L6,13 C5.447,13 5,12.553 5,12 C5,11.447 5.447,11 6,11 L10,11 C10.553,11 11,11.447 11,12 C11,12.553 10.553,13 10,13 M6,3 L8,3 C8.553,3 9,3.447 9,4 C9,4.553 8.553,5 8,5 L6,5 C5.447,5 5,4.553 5,4 C5,3.447 5.447,3 6,3 M13.707,3.293 L10.707,0.293 C10.52,0.105 10.266,0 10,0 L3,0 C2.447,0 2,0.447 2,1 L2,15 C2,15.553 2.447,16 3,16 L13,16 C13.553,16 14,15.553 14,15 L14,4 C14,3.734 13.895,3.48 13.707,3.293'],
  params: {
    width: '16',
    height: '16'
  },
  height: 16,
  width: 16
})));

exports.default = _default;